export var getFormattedFilteredFeatures = function (featuresList) {
    if (!featuresList || !featuresList.length) {
        return [];
    }
    var featuresStringified = featuresList.reduce(function (acc, featureName) { return (acc ? acc + "|" + featureName : featureName); }, '');
    return [featuresStringified];
};
